import React from 'react';
import { useUser } from '../../../../utils/hooks/auth';
import { Table } from '../../../../ui-kit';
import { getHeadCells } from './utils';
import { TablePaginationWithCount, TableProps } from './types';
import ProductStatisticsHeadCell from './TableHead/ProductStatisticsHeadCell';
import TableContent from './TableContent';

const ProductStatisticsTableView = ({ data, pagination, isLoading, rowsPerPage }: TableProps) => {
    const { user: { venueType } } = useUser();
    const [lastCount, setLastCount] = React.useState(0);

    const headCells = getHeadCells(venueType);

    React.useEffect(() => {
        if (data){
            const { productStatistics: { count } } = data;
            setLastCount(count);
        }
    }, [data]);

    const tablePagination: TablePaginationWithCount = { count: lastCount, ...pagination };
    return (
        <Table
            fixedLayout
            headCells={headCells}
            tablePagination={tablePagination}
            TableHeadCellComponent={ProductStatisticsHeadCell}
        >
            <TableContent
                items={data?.productStatistics.items || []}
                isLoading={isLoading}
                rowsPerPage={rowsPerPage}
            />
        </Table>
    );
};

export default ProductStatisticsTableView;
